import { GetAllRulesParams } from './api'

const BASE_KEY = 'payment_approval_rules'

export const paymentApprovalKeys = {
  everything: () => [BASE_KEY],
  allRules: (params?: GetAllRulesParams) => [BASE_KEY, 'all_rules', params],
  approvalRules: () => [BASE_KEY, 'approval_rules'],
  paymentApprovalRules: ({
    programId,
    ruleId,
  }: {
    programId: number
    ruleId: number
  }) => [BASE_KEY, 'payment_approval_rules_details', programId, ruleId],
}
